module.exports = __webpack_public_path__ + "media/img/about/person/ric-a4b9016ba03b359e0cb3a17ca32915af.webp";